module.exports = __webpack_public_path__ + "img/recycle.a1df4760.svg";